import { computed, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RsOverviewServerSideStateManager } from '@rs-shared-lib/abstract-classes/rs-overview-state/rs-overview-server-side-state-manager';
import { RsPersistOverviewState } from '@rs-shared-lib/abstract-classes/rs-overview-state/persistency/rs-persist-overview-state.decorator';
import { rsCountFilters } from '@rs-shared-lib/utils/count-filters/count-filters';
import { ServerSideQueryParams } from '@rs-shared-lib/abstract-classes/rs-overview-state/models/rs-overview-server-side-state-manager';
import { UserService } from '@core/services/user.service';
import { TranslationService, RsUtils } from '@lib/rs-ngx';
import { environment } from '@environments/environment';
import { MRT_DEFAULT_PAGE_SIZE, MRT_PAGE_SIZE_OPTIONS } from '@shared/constants/mrt-page-size-options';
import { SupplierGroupSummary } from '@shared/models/supplier-groups/supplier-group-summary';
import { isBoolean } from 'lodash';

export type SupplierGroupsFilters = {
  code: string;
  description: string;
  active: boolean | null;
};

@RsPersistOverviewState({
  storageKeySuffix: 'MrtLeasingCompanySupplierGroups',
  includeUserContext: () => inject(UserService).getCurrentUser()!.loginString,
})
@Injectable()
export class SupplierGroupsOverviewStateService extends RsOverviewServerSideStateManager<SupplierGroupSummary, SupplierGroupsFilters> {
  public readonly filterCount = computed(() => {
    const { active, ...restFilters } = this.filters();
    return rsCountFilters(restFilters) + (isBoolean(active) ? 1 : 0);
  });

  constructor() {
    const http = inject(HttpClient);
    const currentLanguage = inject(TranslationService).currentLang;

    super({
      serviceMethod: (params: ServerSideQueryParams<SupplierGroupsFilters>) => {
        return http.get<SupplierGroupSummary[]>(
          `${environment.apiUrl}/leasing-company/supplier-group`,
          {
            params: RsUtils.trimEmptyHttpParams({
              ...params,
              userLanguage: currentLanguage(),
            }),
            observe: 'response',
          },
        );
      },
      initialSortingState: { active: 'NAME', direction: 'asc' },
      initialFiltersState: {
        code: '',
        description: '',
        active: null,
      },
      initialPagination: { pageIndex: 0, pageSize: MRT_DEFAULT_PAGE_SIZE },
      config: { pageSizeOptions: MRT_PAGE_SIZE_OPTIONS },
    });
  }
}
